export const getTransform = (
  placement: 'top' | 'right' | 'bottom' | 'left'
) => {
  switch (placement) {
    case 'top':
      return 'translateY(-100%)';
    case 'right':
      return 'translateX(100%)';
    case 'left':
      return 'translateX(-100%)';
    case 'bottom':
      return 'translateY(100%)';
  }
};
